import { unstable_useRoute as useRoute } from 'react-router';

export const useUser = () => useRoute('root').loaderData?.user ?? null;
